export default "__VITE_ASSET__BmVJVLIb__"